import { useContext, useState } from "react";

import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";

import DragAndDrop from "../../components/dragAndDrop/DragAndDrop";
import TextFieldErp from "../../components/basics/TextFieldErp";
import ButtonErp from "../../components/basics/ButtonErp";
import { validTypeFile } from "../../utils/validations";
import { notify } from "../../utils/notify";
import getBase64 from "../../utils/getBase64";
import { ClienteContext } from "../../context/ClienteContext";

const ModalCertificado = () => {
  const [errorsModal, setErrorsModal] = useState({});
  const {
    passwordCertificate,
    setPasswordCertificate,
    file,
    setFile,
    setChangeCertificate,
    changeCertificate,
    setCheckboxCertificado,
    openModalCertificado: open,
    setOpenModalCertificado: setOpen,
  } = useContext(ClienteContext);

  const handleChangePasswordCertificate = (e) => {
    if (!changeCertificate || !changeCertificate.password)
      setChangeCertificate((current) => ({ ...current, password: true }));

    setPasswordCertificate(e.target.value);
  };

  const handleCancel = () => {
    setOpen(false);
    setCheckboxCertificado({ contador: true, cliente: false });
  };

  const handleSave = () => {
    if (!file || !passwordCertificate) {
      if (!passwordCertificate)
        setErrorsModal({ passwordCertificate: "Campo obrigatório" });
      return notify("O arquivo e a senha são de preenchimento obrigatório.");
    }

    setOpen(false);
  };

  const handleFile = async (files) => {
    if (
      !validTypeFile({
        file: files[0],
        types: ["pfx"],
      })
    ) {
      return notify("Só é permitido anexar arquivos do tipo PFX.");
    }

    try {
      const name = files[0].name;
      const certificateB64 = await getBase64(files[0]);
      if (!certificateB64.includes("base64"))
        return notify("Arquivo inválido.");

      setFile({ b64: certificateB64, name });
      setChangeCertificate((current) => ({ ...current, file: true }));
    } catch (err) {
      console.error(err);
    }
  };

  const handleRemoveFile = () => {
    setChangeCertificate((current) => ({ ...current, file: true }));
    setFile(null);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className="modal"
      open={open}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <form onSubmit={() => {}} className="form-certificate-customer">
          <Grid container justify="center">
            <Grid
              item
              xs={11}
              container
              justify="center"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={4}>
                <img
                  alt="Certificado"
                  src="/images/qyonerp-logo.png"
                  style={{ width: "100%", marginTop: 8 }}
                />
              </Grid>
              <Grid
                item
                xs={8}
                className="header-certificate"
                container
                alignItems="center"
              >
                <label
                  style={{
                    fontSize: 20,
                    color: "white",
                    fontWeight: 700,
                    marginLeft: 15,
                  }}
                >
                  Certificado do Cliente
                </label>
              </Grid>

              <Grid item xs={12} style={{ marginTop: 30 }}>
                {file ? (
                  <Grid item container justify="center" alignItems="center">
                    <Grid
                      item
                      container
                      justify="center"
                      alignItems="center"
                      xs={3}
                      style={{
                        border: "solid #afafaf 1px",
                        borderRadius: 10,
                        height: 150,
                        backgroundColor: "#e6e6e6",
                      }}
                    >
                      <label>
                        {file.name
                          ? `${file.name.substring(0, 8)}  ${
                              file.name.length > 8 ? "...PFX" : ""
                            }`
                          : ".PFX"}
                      </label>
                    </Grid>
                    <Grid item container justify="center" alignItems="center">
                      <label
                        onClick={handleRemoveFile}
                        className="label-remove-certificate"
                      >
                        Remover
                      </label>
                    </Grid>
                  </Grid>
                ) : (
                  <DragAndDrop handleFile={handleFile} typesAccept=".pfx" />
                )}
              </Grid>

              <Grid item xs={12} style={{ marginTop: 20 }}>
                <TextFieldErp
                  label="Senha do Certificado*"
                  helperText={errorsModal.passwordCertificate}
                  error={errorsModal.passwordCertificate ? true : false}
                  value={passwordCertificate}
                  setValue={setPasswordCertificate}
                  onChange={handleChangePasswordCertificate}
                />
              </Grid>

              <Grid
                item
                xs={12}
                style={{ marginTop: 30 }}
                container
                justify="flex-end"
              >
                <ButtonErp cancel onClick={handleCancel} />
                <ButtonErp save label="Concluir" onClick={handleSave} />
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Fade>
    </Modal>
  );
};

export default ModalCertificado;
